export const MACHINE_TYPE = {
  jumbo: 'jumbo',
  manitou: 'manitou',
  scoop: 'scoop',
  lhd: 'lhd',
  acunador: 'acunador',
  roboshot: 'roboshot',
  truck: 'truck',
  train: 'train',
  embedded: 'embedded'
};
